// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3xOHJ","card":"Cards_card__3n_SL","infected":"Cards_infected__1Wl9b","recovered":"Cards_recovered__m6xtU","deaths":"Cards_deaths__2kyL0"};